import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tir-pm-crop-form" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "tir-pm-crop-form_wrapper"
}
const _hoisted_4 = {
  key: 2,
  class: "tir-pm-crop-form_buttons"
}
const _hoisted_5 = ["textContent"]

import { CropSelectionModel, TirPmCropper } from "tir-pm-cropper";
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-pm-button";
import { TirPmIconView } from "tir-pm-icon-view";
import {
  PhotoIcon,
  ArrowUpTrayIcon,
  ScissorsIcon,
  CheckIcon,
} from "tir-style-system/icons/outline";
import { computed, ref, watch } from "vue";
import { CropStepEnum } from "./enums";
import { UpdateCropFormData } from "./types";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-crop-form',
  props: {
  /*Исходное изображение */
  srcImage: { type: String },
  /**Можно загружать фото */
  allowEdit: { type: Boolean },
  /**Пропустить подтверждение (для создания) */
  skipConfirm: { type: Boolean, default: false },
  /**Загрузка */
  isLoading: { type: Boolean, default: false }
},
  emits: ["update"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Текущий шаг редактирования */
const step = ref(CropStepEnum.Default);
/**Локальное изображение */
const localImage = ref<string>();
/**Элемент для загрузки файлов */
const $fileInput = ref<HTMLInputElement>();
/**Новое изображение */
const newImage = ref();
/**Обрезаемое изображение */
const cropImage = ref();
/**Параметры обрезки */
const cropParams = ref<CropSelectionModel>();

/**Текст кнопки для загрузки изображения */
const loadButtonText = computed(() => {
  switch (step.value) {
    case CropStepEnum.Default:
      if (!iconImage.value) return "Загрузить фото";
      break;
    case CropStepEnum.Edit:
      return "Загрузить другое фото";
  }
  return "";
});
/**Вариант кнопки для загрузки изображения */
const loadButtonVariant = computed(() => {
  if (step.value == CropStepEnum.Default && !iconImage.value) {
    return TirPmButtonVariantEnum.SecondaryState;
  }
  return TirPmButtonVariantEnum.LinkState;
});
/**Отображаемое изображение */
const iconImage = computed(() => {
  return newImage.value || props.srcImage;
});

/**Сохранить загруженное изображение */
const saveImage = (e: any) => {
  if (!e?.target?.files?.length) return;
  let reader = new FileReader();
  reader.readAsDataURL(e.target.files[0]);
  reader.onload = () => {
    step.value = CropStepEnum.Edit;
    localImage.value = reader.result as string;
  };

  reader.onerror = (error) => console.log("Error: ", error);
};
/**Открыть окно с выбором изображения */
const chooseImage = () => {
  if (!props.allowEdit) return;
  $fileInput.value?.click();
};
/**Перейти на этоп подтверждения обрезки */
const saveCrop = () => {
  if(props.skipConfirm) {
    confirmCrop();
    step.value = CropStepEnum.Default;
  }
  else {
    step.value = CropStepEnum.Confirm;
  }
};
/**Вернуться на этап обрезки текущего изображения */
const cutCurrentImage = () => {
  if (!props.srcImage) return;
  localImage.value = props.srcImage;
  step.value = CropStepEnum.Edit;
};
/**Перейти на этап обрезки */
const cutLocalImage = () => {
  step.value = CropStepEnum.Edit;
};
/**Сохрнать результат обрезки */
const confirmCrop = () => {
  if (!localImage.value || !newImage.value || !cropParams.value) return;

  if (localImage.value && cropParams.value) {
    emit("update", {
      srcImage: localImage.value,
      croppedImage: newImage.value,
      cropSelection: cropParams.value,
    });
  }
};

watch(() => props.isLoading, () => {
  if(!props.isLoading) {
    step.value = CropStepEnum.Default;
  }
});
/**Получение параметров обрезки */
const setCropParams = (params: CropSelectionModel) => {
  cropParams.value = params;
};
/**Получение итогового изображения */
const setCroppedImage = (image: string) => {
  newImage.value = image;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (step.value == _unref(CropStepEnum).Default || step.value == _unref(CropStepEnum).Confirm)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: chooseImage
          }, [
            _createVNode(_unref(TirPmIconView), {
              size: 128,
              isRounded: "",
              isBordered: __props.allowEdit
            }, {
              mainSlot: _withCtx(() => [
                _createVNode(_unref(PhotoIcon), { style: {"width":"5rem","height":"5rem"} }),
                (iconImage.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: iconImage.value,
                      alt: ""
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["isBordered"])
          ]))
        : _createCommentVNode("", true),
      (step.value == _unref(CropStepEnum).Edit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(TirPmCropper), {
              modelValue: cropImage.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cropImage).value = $event)),
              src: localImage.value,
              onSave: saveCrop,
              onCrop: setCropParams,
              onOnCroppedPhoto: setCroppedImage
            }, null, 8, ["modelValue", "src"])
          ]))
        : _createCommentVNode("", true),
      (__props.allowEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (step.value == _unref(CropStepEnum).Default)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (__props.srcImage)
                    ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                        key: 0,
                        size: _unref(TirPmButtonSizeEnum).Small,
                        variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                        onClick: cutCurrentImage
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ScissorsIcon))
                        ]),
                        _: 1
                      }, 8, ["size", "variant"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (step.value == _unref(CropStepEnum).Edit)
              ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                  key: 1,
                  size: _unref(TirPmButtonSizeEnum).Small,
                  variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                  onClick: _withModifiers(saveCrop, ["stop"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CheckIcon))
                  ]),
                  _: 1
                }, 8, ["size", "variant", "onClick"]))
              : _createCommentVNode("", true),
            (step.value == _unref(CropStepEnum).Confirm)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_unref(TirPmButton), {
                    class: "with-text",
                    size: _unref(TirPmButtonSizeEnum).Small,
                    variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                    "is-loading": __props.isLoading,
                    style: {"min-width":"8.5rem"},
                    onClick: _withModifiers(confirmCrop, ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Применить фото ")
                    ]),
                    _: 1
                  }, 8, ["size", "variant", "is-loading", "onClick"]),
                  _createVNode(_unref(TirPmButton), {
                    size: _unref(TirPmButtonSizeEnum).Small,
                    variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                    "is-disabled": __props.isLoading,
                    onClick: _withModifiers(cutLocalImage, ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ScissorsIcon))
                    ]),
                    _: 1
                  }, 8, ["size", "variant", "is-disabled", "onClick"])
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_unref(TirPmButton), {
              class: _normalizeClass({ 'with-text': !!loadButtonText.value }),
              size: _unref(TirPmButtonSizeEnum).Small,
              variant: loadButtonVariant.value,
              "is-disabled": __props.isLoading,
              onClick: chooseImage
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowUpTrayIcon)),
                (loadButtonText.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      textContent: _toDisplayString(loadButtonText.value)
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class", "size", "variant", "is-disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "file",
      ref_key: "$fileInput",
      ref: $fileInput,
      accept: "image/png, image/gif, image/jpeg, .jpg",
      onChange: saveImage
    }, null, 544), [
      [_vShow, false]
    ])
  ], 64))
}
}

})